export default __webpack_public_path__ + "static/media/miscellaneous11.b51bf15a.png";